'use strict';

angular.module('DoohApps').factory('modal2', ['$uibModal', 'DoohLazyLoad', 'DoohConfig', function ($uibModal, DoohLazyLoad, DoohConfig) {
    var modals = {};
    var modalsStack = [];
    // opt: name - modal name, passObj - object we send to modal controller, returnObj - object to which assign value from succesfully closing modal
    return {
        open: function (opt) {
            var templateUrl = getTemplateUrl(opt.name);
            if (modals[templateUrl] == null || typeof modals[templateUrl] == 'undefined') {
                if (opt.backdrop == null || opt.backdrop == undefined)
                    opt.backdrop = true;

                modals[templateUrl] = $uibModal.open({
                    templateUrl: templateUrl,
                    controller: opt.name + 'Controller',
                    windowClass: opt.windowClass,
                    backdrop: opt.backdrop,
                    resolve: getResolveObj(opt.name, opt.passObj)
                });
                modalsStack.push(opt.name);
                modals[templateUrl].result.then((function (returnObj) {
                    if (opt.resolvedCallback != undefined)
                        opt.resolvedCallback(returnObj);
                }), (function () {
                    if (opt.rejectedCallback != undefined)
                        opt.rejectedCallback();
                }));
                // Is resolved when a modal is closed and the animation completes.
                modals[templateUrl].closed.then(function (data) {
                    modalsStack.pop();
                    modals[templateUrl] = undefined;
                    if (opt.finallyCallback != undefined)
                        opt.finallyCallback();
                })
                return true;
            } else return false;
        },
        close: function (modalName) {
            var templateUrl = getTemplateUrl(modalName);
            if (modals[templateUrl] != null && typeof modals[templateUrl] != 'undefined')
                modals[templateUrl].close('close');
        },
        dismiss: function (modalName) {
            var templateUrl = getTemplateUrl(modalName);
            if (modals[templateUrl] != null && typeof modals[templateUrl] != 'undefined')
                modals[templateUrl].dismiss();
        },
        isOpen: function (modalName) {
            var templateUrl = getTemplateUrl(modalName);
            if (modals[templateUrl] == null || typeof modals[templateUrl] == 'undefined') return false;
            return true;
        },
        setLoading: function (modalName, loading) {
            var templateUrl = getTemplateUrl(modalName);
            if (loading)
                modals[templateUrl] = 'loading'; //just so it isn't undefined
            else modals[templateUrl] = undefined;
        },
        isActive: function (modalName) {
            return modalsStack[modalsStack.length - 1] == modalName;
        }
    }

    function getResolveObj(controllerName, passObj) {
        var resolveObj = DoohLazyLoad.loadModalController(controllerName);
        if (passObj != undefined)
            resolveObj['passObj'] = function () { return passObj; };
        return resolveObj;
    }

    function getTemplateUrl(modalName) {
        return `Templates/Modals/${modalName}.html?v=${DoohConfig.version}`;
    }

}]);